import { mapCodeList } from 'redux/selectors/codeLists'

const GET_CODE_LISTS = 'dofe-bo/code-list/GET_CODE_LISTS'
const GET_CODE_LISTS_SUCCESS = 'dofe-bo/code-list/GET_CODE_LISTS_SUCCESS'
const GET_CODE_LISTS_BY_ID_SUCCESS =
  'dofe-bo/code-list/GET_CODE_LISTS_BY_ID_SUCCESS'
const GET_CODE_LISTS_FAIL = 'dofe-bo/code-list/GET_CODE_LISTS_FAIL'

const initialState = {
  genders: {
    loaded: false,
    list: []
  },
  titles: {
    loaded: false,
    list: []
  },
  phoneTypes: {
    loaded: false,
    list: []
  },
  nationalities: {
    loaded: false,
    list: []
  },
  employmentStatuses: {
    loaded: false,
    list: []
  },
  consentDeliveryTypes: {
    loaded: false,
    list: []
  },
  participantPaymentStates: {
    loaded: false,
    list: []
  },
  userRegistrationAssessmentStates: {
    loaded: false,
    list: []
  },
  ajEventCategories: {
    loaded: false,
    list: []
  },
  organizationTypes: {
    loaded: false,
    list: []
  },
  modeOfTransportTypeList: {
    loaded: false,
    list: []
  },
  projectLocationTypes: {
    loaded: false,
    list: []
  },
  organizationContactRoleTypes: {
    loaded: false,
    list: []
  },
  activitySections: {
    loaded: false,
    list: []
  },
  awardFileCategories: {
    loaded: false,
    list: []
  },
  personStates: {
    loaded: false,
    list: []
  },
  awardLevelTypes: {
    loaded: false,
    list: []
  },
  awardStates: {
    loaded: false,
    list: []
  },
  messageTypes: {
    loaded: false,
    list: []
  },
  messageStates: {
    loaded: false,
    list: []
  },
  participantReasonsOfDeletionTypes: {
    loaded: false,
    list: []
  },
  organizationContactReasonsOfDeletionTypes: {
    loaded: false,
    list: []
  },
  organizationStates: {
    loaded: false,
    list: []
  },
  invoiceCurrencies: {
    loaded: false,
    list: []
  },
  vatTreatments: {
    loaded: false,
    list: []
  },
  organizationModes: {
    loaded: false,
    list: []
  },
  awardModes: {
    loaded: false,
    list: []
  },
  labelTypes: {
    loaded: false,
    list: []
  },
  activityReviseReasons: {
    loaded: false,
    list: []
  },
  assessorReasonsOfDeletionTypes: {
    loaded: false,
    list: []
  },
  announcementSeverityStates: {
    loaded: false,
    list: []
  },
  loading: false,
  byId: []
}

export default function reducer(state = initialState, action = {}) {
  const newState = {}

  let requestedLists

  switch (action.type) {
    case GET_CODE_LISTS:
      return {
        ...state,
        loading: true
      }
    case GET_CODE_LISTS_SUCCESS:
      requestedLists = Object.keys(action.result).filter(
        key => action.result[key]
      )

      for (const list of requestedLists) {
        newState[list] = {
          list: mapCodeList(action.result[list], {
            listType: list
          }),
          loading: false,
          loaded: true
        }
      }

      return {
        ...state,
        ...newState,
        loading: false
      }
    case GET_CODE_LISTS_BY_ID_SUCCESS:
      return {
        ...state,
        byId: action.result,
        loading: false
      }
    case GET_CODE_LISTS_FAIL:
      return {
        ...state,
        loading: false
      }
    default:
      return state
  }
}

export function getLists(lists = '') {
  return {
    types: [GET_CODE_LISTS, GET_CODE_LISTS_SUCCESS, GET_CODE_LISTS_FAIL],
    promise: client => client.get(`api/code-list?lists=${lists}`)
  }
}

export function getListById(id) {
  return {
    types: [GET_CODE_LISTS, GET_CODE_LISTS_BY_ID_SUCCESS, GET_CODE_LISTS_FAIL],
    promise: client =>
      client.get(`api/code-list/${id}?sortByTranslatedName=true`)
  }
}

export function getPublicLists(lists = '') {
  return {
    types: [GET_CODE_LISTS, GET_CODE_LISTS_SUCCESS, GET_CODE_LISTS_FAIL],
    promise: client => client.get(`api/registration/code-list?lists=${lists}`)
  }
}
